import React from "react";
import "./Footer.css";
import { FaWhatsapp, FaFacebookF, FaInstagram, FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">

        {/* About Section */}
        <div className="footer-column">
          <h3>About</h3>
          <p>
            <strong>SaiSree Hardwares & Electricals</strong> offers premium quality paints, tools, and Electricals materials 
            to help you transform your spaces beautifully.
          </p>
          <p>
            We ensure top brands and reliable service for both homes and businesses.
          </p>
        </div>

        {/* Services Section */}
        <div className="footer-column">
          <h3>Services</h3>
          <ul>
            <li><a href="#paints">Paints</a></li>
            <li><a href="#gallery">Hardwares</a></li>
          </ul>
        </div>

        {/* Quick Links Section */}
        <div className="footer-column">
          <h3>Quick Links</h3>
          <ul>
            <li><a href="#home">Home</a></li>
            <li><a href="#about">About</a></li>
            <li><a href="#services">Services</a></li>
            <li><a href="#gallery">Gallery</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </div>

        {/* Contact Section */}
        <div className="footer-column">
          <h3>Contact</h3>
          <p><FaPhoneAlt /> +91 9443777668</p>
          <p><FaEnvelope /> saisreeenterprises2017@gmail.com</p>
          <p><FaMapMarkerAlt /> Sivapriya Nagar,Senthangudy,Mayiladuthurai</p>

          <div className="footer-social">
            <a href="https://wa.me/919443777668" target="_blank" rel="noopener noreferrer"><FaWhatsapp /></a>
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} SaiSree Hardwares & Electricals. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
